import { render, staticRenderFns } from "./ContentHeroSundayDesktop.vue?vue&type=template&id=ae378fc4&scoped=true&"
import script from "./ContentHeroSundayDesktop.vue?vue&type=script&lang=js&"
export * from "./ContentHeroSundayDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ContentHeroSundayDesktop.vue?vue&type=style&index=0&id=ae378fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae378fc4",
  null
  
)

export default component.exports